// eslint-disable-next-line import/no-extraneous-dependencies
import "whatwg-fetch";
import { fetchCharge } from "./charge";
import { resetRedirection, resetRedirectionParams } from "./redirect";

export const REQUEST_OTP = "REQUEST_OTP";
export const RECEIVE_OTP = "RECEIVE_OTP";
export const REGENERATE_OTP = "REGENERATE_OTP";
export const RECEIVE_REGENERATE_OTP_RESPONSE =
  "RECEIVE_REGENERATE_OTP_RESPONSE";
export const RECEIVE_ERROR_OTP_PARAMS = "RECEIVE_ERROR_OTP_PARAMS";
export const RESET_OTP_ERROR = "RESET_OTP_ERROR";
export const RESET_OTP_REDIRECTION = "RESET_OTP_REDIRECTION";
export const RESET_OTP_PARAMS = "RESET_OTP_PARAMS";

function requestOtp() {
  return {
    type: REQUEST_OTP
  };
}

function receiveOtpParams(otpParams) {
  return {
    type: RECEIVE_OTP,
    otpParams
  };
}

function regenerateOtpParams() {
  return {
    type: REGENERATE_OTP
  };
}

function receiveRegenerateOtpResponse(otpParams) {
  return {
    type: RECEIVE_REGENERATE_OTP_RESPONSE,
    otpParams
  };
}

function receiveOtpError(message) {
  return {
    type: RECEIVE_ERROR_OTP_PARAMS,
    message
  };
}

export function resetOtpError() {
  return { type: RESET_OTP_ERROR };
}

export function resetOtpRedirection(message) {
  return {
    type: RESET_OTP_REDIRECTION,
    message
  };
}

export function resetOtpParams() {
  return {
    type: RESET_OTP_PARAMS
  };
}

const getCsrfToken = () => {
  const token = document.cookie.match(
    "(^|[^;]+)\\s*XSRF-TOKEN\\s*=\\s*([^;]+)"
  );
  return token ? token.pop() : "";
};

export function regenerateOtp(uuid) {
  return dispatch => {
    dispatch(regenerateOtpParams());
    return window
      .fetch(`/public/v1/tx/${uuid}/generateOTP`, { method: "GET" })
      .then(
        resp => {
          if (resp.status === 205) window.location.reload();
          return resp.json();
        },
        error => dispatch(receiveOtpError(error))
      )
      .then(json => {
        if (json.code && json.message) throw new Error(json.message);
        dispatch(receiveRegenerateOtpResponse(json));
      })
      .catch(e => {
        dispatch(receiveOtpError(e.message));
      });
  };
}

export function fetchOtpParams(uuid, form, chargeuuid) {
  return dispatch => {
    dispatch(requestOtp());
    return window
      .fetch(`/public/v1/tx/${uuid}/verifyOTP`, {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        }
      })
      .then(
        resp => {
          if (resp.status === 205) window.location.reload();
          return resp.json();
        },
        error => dispatch(receiveOtpError(error))
      )
      .then(json => {
        if (json.responseCode === "450" || json.responseCode === "451") {
          const errorMessage = json.message
            ? json.message
            : "OTP is Invalid or Expired";
          throw new Error(errorMessage);
        }
        dispatch(resetRedirectionParams());
        dispatch(receiveOtpParams(json));
        dispatch(resetOtpRedirection());
        dispatch(resetRedirection());
        dispatch(fetchCharge(chargeuuid));
        window.history.back();
      })
      .catch(e => {
        dispatch(receiveOtpError(e.message));
      });
  };
}
